import numeral from 'numeral';

export default (
    value: number | string | null,
    showDecimals: boolean = true,
    decimalsFormat: string = '0,0.[00]'
) => {
    if (value == null) {
        return null;
    }

    const parsedValue = parseFloat(value);

    if (!showDecimals) {
        return numeral(parsedValue).format('0,0');
    }

    return Math.abs(parsedValue) < 0.01
        ? parsedValue.toPrecision(1)
        : numeral(parsedValue).format(decimalsFormat);
};
